/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { viewBankById } from "../core/_requests";
import EditSettlements from "./EditSettlements";


export const EditBasicDetailsWrapper = () => {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    viewBankById(id).then((res) => {
      setData(res.data);
    });
  }, []);

  if (data) {
    return <EditSettlements initialValues={data} />;
  }
  return null;
};
